<template>
    <div class="absolute inset-0" data-testid="killer-win-splash">
        <img
            :src="hud"
            alt=""
            class="pointer-events-none absolute top-0 left-1/2 max-w-none -translate-x-1/2"
        />
        <h2
            class="font-title absolute inset-x-0 top-[60px] text-center text-[25px] leading-none font-bold uppercase"
            :style="{ color }"
            data-testid="killer-winner-name"
        >
            {{ player.tag_name }}
        </h2>
        <div class="absolute inset-x-0 top-[101px] flex justify-center">
            <KillerBadge
                :avatar="player.avatar"
                :color="color"
                :label="$t('killer.winner')"
                class="w-[146px]"
            />
        </div>
        <h3
            class="font-title absolute inset-x-0 top-[337px] text-center text-[20px] leading-none font-black text-white uppercase"
        >
            {{ $t('killer.targets_killed') }}
        </h3>
        <KillerPlayerCardList
            :players="targets"
            :max-card-width="175"
            :height="352"
            class="absolute inset-x-0 top-[383px]"
        />
        <div class="absolute inset-x-0 top-[762px] flex justify-center">
            <KillerMenuButton
                class="w-[320px]"
                data-testid="killer-main-menu"
                @click="$emit('main-menu')"
            >
                {{ $t('killer.main_menu') }}
            </KillerMenuButton>
        </div>
    </div>
</template>

<script>
import KillerBadge from '../ui/KillerBadge.vue'
import KillerMenuButton from '../ui/KillerMenuButton.vue'
import KillerPlayerCardList from '../ui/KillerPlayerCardList.vue'
import hud from '@/assets/images/games/killer/splash/hud-win.svg'

export default {
    name: 'KillerSplashWin',
    components: { KillerBadge, KillerMenuButton, KillerPlayerCardList },
    props: {
        player: {
            type: Object,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        targets: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['main-menu'],
    data() {
        return {
            hud,
        }
    },
}
</script>
